// type guard to check if the key parameter is found in the object parameter.
// ex: isKeyOfObject("lunch", mealsOfTheDay)

export const isKeyOfObject = <T extends object>(key: PropertyKey | null | undefined, object: T): key is keyof T =>
  key ? key in object : false;
